import { useLang } from "../lib/i18n";

export default function Footer() {
  const { t } = useLang();
  return (
    <footer className="border-t-2 border-slate-900 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8 flex flex-col sm:flex-row gap-4 items-center justify-between">
        <img src="/logo.png" alt="Pet Munchies" className="h-10 w-auto object-contain" data-testid="footer-logo" />
        <p className="text-xs text-slate-500 text-center sm:text-end">
          © {new Date().getFullYear()} Pet Munchies. {t("footer.made")} {t("footer.rights")}
        </p>
      </div>
    </footer>
  );
}
